import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ForgotPasswordModel } from 'src/app/models/Auth.model';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.component.html',
  styleUrls: ['./forgot-pass.component.css'],
})
export class ForgotPassComponent {
  ForgetPassForm!: FormGroup;
  forgotPassword: ForgotPasswordModel = new ForgotPasswordModel();
  submitted = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authservice: LoginService,
    private formBuilder: FormBuilder
  ) {}
  ngOnInit(): void {
    this.ForgetPassForm = this.formBuilder.group({
      UserName: ['', Validators.required],
    });
  }

  validateUsername() {
    this.submitted = true;
  }

  onSubmit() {
    console.log(this.ForgetPassForm.value.UserName);

    this.authservice
      .forgotPassword(this.ForgetPassForm.value.UserName)
      .subscribe(
        (data) => {
          alert(
            'Please check your registered email for an email to reset your password.'
          );
          this.router.navigate(['/authentication/login']);
        },
        (customError) => {
          alert(
            `Could not send email to your registered email account.
            ${customError.message}`
          );
        }
      );
  }
}
